import axios from "axios";
import { del, get, post, patch,  put } from "./defenses_api_helper";
import * as url from "./defenses_url_helper";





// Get features
export const getDefenses = () => get(url.GET_DEFENSES);


// Add feature
//export const addNewFeature = feature => post(url.ADD_NEW_ACTION, feature);
//export const addNewBranch = branch => post(url.ADD_NEW_BRANCH, JSON.stringify(branch));

export const addNewDefense = defense => post(url.ADD_NEW_DEFENSE, defense, {headers: { "Content-Type": "application/json" }});



// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateDefense = defense => patch(`${url.UPDATE_DEFENSE}/${defense.id}`,  defense);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deleteDefense = defense => del(`${url.DELETE_DEFENSE}/${defense.id}`);







export {
  //getLoggedInUser,
  
  
};
